
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import {
  Operation,
} from '@/types';

moment.locale('it');

@Component
export default class OperationFinalPaymentDate extends Vue {
  @Prop(Object) readonly operation!: Operation;

  get latestPaymentDate(): string | null {
    return this.operation
      && this.operation.latestPaymentDate
      && moment(this.operation.latestPaymentDate).isValid()
      ? moment(this.operation.latestPaymentDate).format('L')
      : null;
  }

  get columnClass(): string {
    return '';
  }

  onEdit() {
    console.log('OperationFinalPaymentDate: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
